import i18n from "i18next";
import { z } from "zod";

export const normalizeDate = (date: Date | string | null | undefined): Date | null => {
  if (!date) return null;
  const d = new Date(date);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const getMustBeAfterMessage = (subject: string, object: string) =>
  i18n.t("form-validation.must-be-after", { subject, object });

export const getNotifyOptionRequiredMessage = () =>
  i18n.t("vessel-call.port-services.fields.notify-option-required");

export const getAtsMustNotBeInPastError = (ats: Date | string | null | undefined) => {
  const normalizedAts = normalizeDate(ats);

  if (!normalizedAts || normalizedAts >= new Date()) {
    return undefined;
  }

  return i18n.t("form-validation.must-not-be-in-past", { label: "ATS" });
};

export const getAtcAfterAtsError = (
  atc: Date | string | null | undefined,
  ats: Date | string | null | undefined,
) => {
  const normalizedAtc = normalizeDate(atc);
  const normalizedAts = normalizeDate(ats);

  if (!normalizedAtc || !normalizedAts || normalizedAtc > normalizedAts) {
    return undefined;
  }

  return getMustBeAfterMessage("ATC", "ATS");
};

export const getEtcDateOrderError = ({
  etc,
  ets,
  ats,
}: {
  etc: Date | string | null | undefined;
  ets?: Date | string | null | undefined;
  ats?: Date | string | null | undefined;
}) => {
  const normalizedEtc = normalizeDate(etc);
  const normalizedEts = normalizeDate(ets);
  const normalizedAts = normalizeDate(ats);

  if (!normalizedEtc) {
    return undefined;
  }

  if (normalizedEts && normalizedEtc <= normalizedEts) {
    return getMustBeAfterMessage("ETC", "ETS");
  }

  if (normalizedAts && normalizedEtc <= normalizedAts) {
    return getMustBeAfterMessage("ETC", "ATS");
  }

  return undefined;
};

export const notificationSchema = z.object({
  notificationOption: z.array(z.string()).min(1, {
    message: getNotifyOptionRequiredMessage(),
  }),
});

export const isWasteDisposal = (category: string) => {
  return category === "Waste Disposal";
};

export const isWasteDisposalGarbage = (category: string, type: string) => {
  return isWasteDisposal(category) && type === "Garbage";
};

export const isWasteDisposalSludge = (category: string, type: string) => {
  return isWasteDisposal(category) && type === "Sludge";
};

export const isWasteDisposalSlops = (category: string, type: string) => {
  return isWasteDisposal(category) && type === "Slops";
};

export const isBunkering = (category: string) => {
  return category === "Bunkering";
};

export const isDebunkering = (category: string) => {
  return category === "De-bunkering";
};

export const isDeSloping = (category: string) => {
  return category === "De-sloping";
};
